import * as React from 'react';
import { observer } from 'mobx-react-lite';
import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import { getMeetingSummaryProps } from '../../utils/getMeetingSummaryProps';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

const styles = require('./MeetingIcon.scss');
const classNames = require('classnames');

export interface MeetingIconProps {
    message: MeetingMessage;
    senderPersona?: JSX.Element;
    className?: string;
}

const MeetingIcon: React.FunctionComponent<MeetingIconProps> = observer(props => {
    const { message, senderPersona, className } = props;

    const summaryProps = getMeetingSummaryProps(message);

    if (summaryProps) {
        return (
            <div className={classNames(styles.iconContainer, className)}>
                <Icon iconName={summaryProps.icon} className={styles.icon} />
            </div>
        );
    } else {
        return senderPersona;
    }
});

export default MeetingIcon;
